import "styles/legacy/delete-account-modal.css";
import { userApi } from "shared/api/client/orval";

interface DeleteAccountModalProps {
  open: boolean;
  onClose: () => void;
  userId: string;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({
  open,
  onClose,
  userId,
}) => {
  if (!open) return null;

  const handleDeleteAccount = () => {
    console.log("Deleting account for user:", userId);
    userApi
      .deleteApiUserDeleteId(Number.parseInt(userId, 10))
      .then(() => {
        console.log(`User ${userId} deleted successfully.`);
        document.cookie =
          "userToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie =
          "userId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie =
          "userIsVerified=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie =
          "userRole=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  return (
    <div className="delete-account-modal-overlay" onClick={onClose}>
      <div
        className="delete-account-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-password-top-div">
          <img
            src="/images/icons/warning.svg"
            alt="warning"
            className="delete-password-warning-icon"
          />
          <div className="delete-account-title">Delete account?</div>
        </div>
        <div className="delete-account-subtitle">
          By deleting your account, all relevant data will be removed and won't
          be retrievable
        </div>
        <div className="delete-account-button-container">
          <button
            className="delete-account-buttons"
            id="cancel-button-delete-account"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="delete-account-buttons"
            id="delete-button-delete-account"
            onClick={handleDeleteAccount}
          >
            Delete account
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
